import React from "react";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";

export default function Terms() {
    return (
        <div data-testid="terms-page">
            <SEO
                title="Terms — Moving Mountains Advisors"
                description="Ground rules for using Moving Mountains and our AI concierge Jarvis. No guarantees on approval, rates, or outcomes."
            />
            <PageHeader
                eyebrow="Legal"
                title="Terms of Use."
                subtitle="The ground rules for using our site, Jarvis, and our advisory services."
            />
            <section className="mm-section bg-white">
                <div className="mm-container max-w-3xl space-y-6 text-mm-ink leading-relaxed">
                    <p>
                        By using this website and our services you agree to these
                        Terms. If you do not agree, please do not use the site.
                    </p>
                    <h3 className="mm-display text-xl text-mm-navy">No guarantees</h3>
                    <p>
                        Moving Mountains Inc. does not guarantee approval, rates,
                        premiums, returns, tax outcomes, or any financial result.
                        Approval and final pricing are determined by the issuing
                        insurance carrier based on underwriting. Nothing on this site
                        constitutes a binding offer of coverage.
                    </p>
                    <h3 className="mm-display text-xl text-mm-navy">Not legal or tax advice</h3>
                    <p>
                        Content on this site — including from our AI concierge
                        Jarvis — is educational and not a substitute for
                        professional legal, tax, or medical advice.
                    </p>
                    <h3 className="mm-display text-xl text-mm-navy">AI disclosure</h3>
                    <p>
                        This experience is powered by advanced AI technology. A
                        licensed advisor reviews every recommendation before any
                        application is submitted on your behalf.
                    </p>
                    <h3 className="mm-display text-xl text-mm-navy">Data</h3>
                    <p>
                        We do not sell your data. See our{" "}
                        <a className="mm-link" href="/privacy">
                            Privacy Policy
                        </a>{" "}
                        for details.
                    </p>
                </div>
            </section>
        </div>
    );
}
